import { render, staticRenderFns } from "./AddDevice.vue?vue&type=template&id=65536b88&scoped=true&"
import script from "./AddDevice.vue?vue&type=script&lang=js&"
export * from "./AddDevice.vue?vue&type=script&lang=js&"
import style0 from "./AddDevice.vue?vue&type=style&index=0&id=65536b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65536b88",
  null
  
)

export default component.exports